import React from 'react';
import {Sections} from 'components';
import css from './reviews.scss';

export function Reviews(props) {
  return (
    <div className={css.section}>
      <h4 className={css('title', props)}>Endorsements and Reviews</h4>
      <div className={css('container', props)}>
        <Sections>
          {reviews.map(review => props =>
            <Card {...review} {...props} className={css.card} key={review.name} />
          )}
        </Sections>
      </div>
    </div>
  );
}

function Card(props) {
  return (
    <div className={css.cardWrap}>
      <div className={[props.className, props.visible && css.visible].join(' ')}>
        <blockquote>
          {props.review}
        </blockquote>
        <div className={css.author}>
          <figure>
            <img src={props.photo} alt={props.name} />
          </figure>
          <div>
            <b>{props.name}</b>
            {props.company}
          </div>
        </div>
      </div>
    </div>
  );
}

const reviews = [
  {
    name: 'Tony Robbins',
    company: 'Life and Business Strategist',
    review: 'Setting Goals is the first step turning the invisible to visible',
    photo: require('./photos/tony.jpg')
  },
  {
    name: 'Bob Proctor',
    company: 'Renowned International Speaker',
    review: 'Yuval has created a masterpiece of a coaching program with the Wizard..... look at it very closely, it is pure Genius!',
    photo: require('./photos/bob.jpg')
  },
  {
    name: 'Gay Hendricks, Ph.D.',
    company: 'Bestselling Author',
    review: "I am very impressed with Yuval Goren's remarkable Success Wizard program. What's especially brilliant about it is how easy it is to use. It's the best system I've seen for people who want to create major results in their lives.",
    photo: require('./photos/hendricks.jpg')
  }
];
